export enum InstallmentProviderType {
    Unknown = 'unknown',
    Sberbank = 'sberbank',
    Otp = 'otp',
    VsegdaDa = 'vsegdaDa',
    FreedomFinance = 'freedomFinance',
    Tinkoff = 'tinkoff',
    Dolyame = 'dolyame',
    YandexSplit = 'yandexSplit',
    FreshCredit = 'freshCredit',
    ProOnline = 'proOnline',
    DirectCredit = 'directCredit'
}
